module.exports = __webpack_public_path__ + "band_12.4a526b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_12.png
// module id = 8dE2
// module chunks = 0